
export class Elements {

    private static _contentContainer: HTMLElement|null =   null;
    private static _siteTitle: HTMLElement|null =   null;
    private static _help: HTMLElement|null = null;
    private static _menu: HTMLElement|null = null;
    private static _left: HTMLDivElement|null = null;
    private static _right: HTMLDivElement|null = null;
    
    public static get contentContainer() : HTMLElement { 
        if( Elements._contentContainer === null ) {
            Elements._contentContainer = document.body.querySelector('main') as HTMLElement;
        }
        return Elements._contentContainer;
    }

    public static get siteTitle() : HTMLElement { 
        if( Elements._siteTitle === null ) {
            Elements._siteTitle = document.body.querySelector('.title') as HTMLElement;
        }
        return Elements._siteTitle;
    }

    public static get help() : HTMLElement { 
        if( Elements._help === null ) {
            Elements._help = document.body.querySelector('.help') as HTMLElement;
        }
        return Elements._help;
    }

    public static get menu() : HTMLElement { 
        if( Elements._menu === null ) {
            Elements._menu = document.body.querySelector('aside') as HTMLElement;
        }
        return Elements._menu;
    }

    public static get leftSidebar() : HTMLDivElement {
        if( Elements._left === null ) {
            Elements._left = document.body.querySelector('.left') as HTMLDivElement;
        }
        return Elements._left;
    }

    public static get rightSidebar() : HTMLDivElement {
        if( Elements._right === null ) {
            Elements._right = document.body.querySelector('.right') as HTMLDivElement;
        }
        return Elements._right;
    }
}